var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUmbrella(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18,
    cy: 30.54,
    fill: "#3b88c3",
    rx: 18,
    ry: 5.36
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m33.813 28.538c0 1.616-2.5 2.587-14.482 2.587-10.925 0-13.612-.971-13.612-2.587s5.683-2.926 13.612-2.926 14.482 1.31 14.482 2.926z",
    fill: "#88c9f9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7 28.25c0-1 1-5 11-5 12 0 15 4 15 5s0 2-14 2c-12 0-12-1-12-2z",
    fill: "#f4900c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m20.62 27.667c-.15.692-.835 1.133-1.527.982-.693-.15-1.133-.834-.983-1.527l5.083-25.985c.15-.693.834-1.132 1.527-.982.691.15 1.133.834.981 1.527z",
    fill: "#66757f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m24.358 1.827c-7.622-1.654-14.857 1.873-16.16 7.878 0 0-.363 1.672.474 1.854.836.182 2.872-1.128 2.872-1.128l20.908 4.538s1.309 2.036 2.146 2.218 1.199-1.491 1.199-1.491c1.304-6.006-3.818-12.215-11.439-13.869z",
    fill: "#dd2e44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m24.358 1.827c-5.774-1.253-11.511 2.599-12.814 8.603 0 0-.363 1.673 1.31 2.036 1.673.364 4.545-.765 4.545-.765l9.199 1.997s2.146 2.217 3.819 2.581c1.673.362 2.035-1.311 2.035-1.311 1.303-6.004-2.321-11.888-8.094-13.141z",
    fill: "#ffe8b6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m24.358 1.827c-3.003-.651-5.657 3.87-6.96 9.874 0 0 2.146 2.218 3.818 2.58l.837.183c1.673.362 4.544-.766 4.544-.766 1.304-6.004.764-11.219-2.239-11.871z",
    fill: "#dd2e44"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m15.844 27.948c.469-.427 1.75-.326 2.5-.602s1.219-.627 1.844-.376.812.627 1.406.678 1.031.402.781.678-2.219.376-3.531.376-3.579-.226-3-.754z",
    fill: "#ffac33"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbrella);
export default __webpack_public_path__ + "static/media/umbrella.84566ca77d155f8cb19e340f821cfa13.svg";
export { ForwardRef as ReactComponent };